import React, {useContext} from 'react';
import './Confirmation.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import ErrorIcon from 'new-images/error.svg';
import {Message} from 'compositions/message/Message';
import {Button} from "elements/button/Button";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";


export const PICKUP_CONFIRMATION_POPUP = 'PICKUP_WARNING_MESSAGE_POPUP';
export const LOGOUT_CONFIRMATION_POPUP = 'LOGOUT_CONFIRMATION_POPUP';
export const INCOMPATIBLE_CART_CONFIRMATION_POPUP = 'INCOMPATIBLE_CART_CONFIRMATION_POPUP';
export const CARD_PAYMENT_CONFIRMATION_POPUP = 'CARD_PAYMENT_CONFIRMATION_POPUP';
export const LOCATION_PERMISSION_CONFIRMATION_POPUP = 'LOCATION_PERMISSION_CONFIRMATION_POPUP';
export const CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP = 'CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP';
export const REPEAT_ORDER_CONFIRMATION_POPUP = 'REPEAT_ORDER_CONFIRMATION_POPUP';
export const REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP = 'REPEAT_ORDER_FROM_HISTORY_CONFIRMATION_POPUP';

export const Confirmation = ({title, description, onOverlayClick, onYesClick, onNoClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onNoClick}>
			{getSafeTranslation('ConfirmationPopup.cancelButtonCaption', translations)}
		</Button>}
		rightControl={<Button isAutoWidth onClick={onYesClick}>{
			getSafeTranslation('ConfirmationPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="confirmation">
			<Message
				icon={ErrorIcon}
				title={title}
				description={description}
			/>
		</div>
	</DrawerPopup>
}
